/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Max_Tps_Switch_To_Hundred_BlocksInputs */



/**
* | output |
* | --- |
* | "Switch to Max TPS (100 blocks)" |
*
* @param {Metric_Max_Tps_Switch_To_Hundred_BlocksInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_max_tps_switch_to_hundred_blocks = /** @type {((inputs?: Metric_Max_Tps_Switch_To_Hundred_BlocksInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Max_Tps_Switch_To_Hundred_BlocksInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch to Max TPS (100 blocks)")
});